/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron-down': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.576 7.976a.6.6 0 01.848 0L12 16.552l8.576-8.576a.6.6 0 01.848.848l-9 9a.6.6 0 01-.848 0l-9-9a.6.6 0 010-.848z" _fill="currentColor"/>'
  }
})
